import NotificationDescription from './NotificationDescription'

export default NotificationDescription
